import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Invisible component that tracks page visits for analytics.
 * Place inside <Router> to access useLocation().
 */
const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/mm-admin')) {
      return;
    }

    const timer = setTimeout(() => {
      try {
        fetch('/api/analytics/track', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer || ''
          })
        }).catch(() => {}); // silently fail
      } catch {
        // ignore
      }
    }, 500); // small delay to avoid tracking instant navigations

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
